import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './Responsive.css';
import AppShell from './AppShell';
import { AtomLoader } from './components/preloader/AtomicPreloader';
// Home is eager (prerendered primary route); secondary routes stay lazy.
import Home from './pages/home/Home';

const SuccessPage = lazy(() => import('./pages/contact/SuccessPage'));
const SitemapPage = lazy(() => import('./pages/sitemap/SitemapPage'));
const BlogsPage   = lazy(() => import('./pages/blog/BlogsPage'));
const BlogPost    = lazy(() => import('./pages/blog/BlogPost'));
const AdminApp    = lazy(() => import('./pages/admin/AdminApp'));
const NotFound    = lazy(() => import('./pages/NotFound'));

const App = () => {
  return (
    <AppShell>
      <Router>
        <Suspense fallback={<AtomLoader />}>
          <Routes>
            <Route path="/" element={<Home />}/>
            <Route path="/success" element={<SuccessPage />}/>
            <Route path="/sitemap" element={<SitemapPage />}/>
            <Route path="/blog" element={<BlogsPage />}/>
            <Route path="/blog/:slug" element={<BlogPost />}/>
            <Route path="/admin/*" element={<AdminApp />}/>
            <Route path="*" element={<NotFound />}/>
          </Routes>
        </Suspense>
      </Router>
    </AppShell>
  );
};

export default App;
